// extracted by mini-css-extract-plugin
module.exports = {"cls1":"about-NewsContainer-module--cls1--srjlo","cls2":"about-NewsContainer-module--cls2--2xb7N about-NewsContainer-module--cls1--srjlo"};